import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyDUHCjWtGQCwwu4RUTTmSe2Z8BagqKgIKg",
    authDomain: "samporoadmap.firebaseapp.com",
    projectId: "samporoadmap",
    storageBucket: "samporoadmap.firebasestorage.app",
    messagingSenderId: "232724220531",
    appId: "1:232724220531:web:43a3c9b2d54b190e08b806",
    measurementId: "G-0RP81TGVHC"
  };

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const firestore = getFirestore(app);